import Image from "next/image";

export const ImageViewer = ({
  mediaURL,
  gameTitle,
  handleCloseMedia,
}: { mediaURL: string; gameTitle?: string; handleCloseMedia: () => void }) => (
  <button type="button" onClick={handleCloseMedia}>
    {/* Blurred media */}
    <Image
      src={mediaURL}
      alt={`${gameTitle ?? "Game"} Art`}
      fill
      className="object-fill blur-xl brightness-50"
      sizes="(max-width: 640px) 100vw, 92vw"
    />

    <Image
      src={mediaURL}
      alt={`${gameTitle ?? "Game"} Art`}
      fill
      className="object-contain"
      sizes="(max-width: 640px) 100vw, 92vw"
      priority
    />
  </button>
);
